import storage from 'simplestorage.js';

let instance = null;

const UI_STORAGE_KEY = 'dennisUI';
const GAME_STORAGE_KEY = 'dennisGAME';

/**
 * Storage looks like:
 *
 * {
 *   dennisGAME: {
 *     slots: { slots: ['PLAYER_ONE'] },
 *     savePLAYER_ONE: { id: 'PLAYER_ONE', bestLevelTimes: [533, 433, 483] },
 *   },
 *   dennisUI: {
 *     muted: false,
 *   },
 *
 */

class Settings {
  constructor() {
    if (!instance) {
      this._storageIsAllowed = storage.canUse();
      if (!this._storageIsAllowed) {
        console.warn('LOCAL STORAGE DISABLED');
      }
      this._loadLocalData();
      instance = this;
    }
    return instance;
  }

  destroy() {
    instance = null;
  }

  toggleAudio() {
    const state = !this.getAudio();
    this._setAudio(state);
    return { isMuted: !state };
  }
  setAudio(value) {
    this._setAudio(value);
  }
  getAudio() {
    return this.getAllSettings().audio;
  }
  getIsMuted() {
    return !this.getAllSettings().audio;
  }

  /**
   * LOCAL STORAGE API
   */
  getAllSettings() {
    let settings = JSON.parse(JSON.stringify(this.globalSettings));
    settings.audio = !settings.muted;
    if (this._isStorageAllowed()) {
      settings.gameData = this.gameSettings;
    } else {
      console.warn('getAllSettings : storage disabled');
    }
    return settings;
  }

  setGameData(key, value) {
    if (this._isStorageAllowed()) {
      this.gameSettings[key] = value;
      storage.set(GAME_STORAGE_KEY, JSON.stringify(this.gameSettings));
    } else {
      console.warn('setGameData : storage disabled');
    }
  }

  /**
   * LOCAL STORAGE PRIVATE
   */
  _setAudio(state) {
    this.globalSettings.muted = !state;
    this._saveGlobalSettings();
  }

  _loadLocalData() {
    if (this._isStorageAllowed()) {
      this.globalSettings = this._parseLocalStorage(UI_STORAGE_KEY);
      this.gameSettings = this._parseLocalStorage(GAME_STORAGE_KEY) || {};
      if (!this.globalSettings) {
        this.globalSettings = this._getDefaultSettings();
        this._saveGlobalSettings();
      }
    }
  }

  _saveGlobalSettings() {
    if (this._isStorageAllowed()) {
      storage.set(UI_STORAGE_KEY, JSON.stringify(this.globalSettings));
    }
  }

  _isStorageAllowed() {
    return this._storageIsAllowed;
  }

  _getDefaultSettings() {
    const defaults = {};
    defaults.muted = false;
    return defaults;
  }

  _parseLocalStorage(key) {
    const data = storage.get(key);
    try {
      return JSON.parse(data);
    } catch (e) {}
    return null;
  }
}
export default Settings;
